"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useManualPromise = void 0;
var _react = require("react");
const useManualPromise = () => {
  const promiseRef = (0, _react.useRef)({
    promise: null,
    resolve: null,
    reject: null,
    status: 'idle'
  });
  const createPromise = () => {
    promiseRef.current.promise = new Promise((resolve, reject) => {
      promiseRef.current.resolve = value => {
        resolve(value);
        promiseRef.current.status = 'resolved';
      };
      promiseRef.current.reject = error => {
        reject(error);
        promiseRef.current.status = 'rejected';
      };
      promiseRef.current.status = 'pending';
    });
    return promiseRef.current.promise;
  };
  return {
    createPromise,
    resolve: promiseRef.current.resolve,
    reject: promiseRef.current.reject,
    status: promiseRef.current.status
  };
};
exports.useManualPromise = useManualPromise;